import { Routes, Route } from 'react-router-dom'
import { useEffect } from 'react'
import { AuthProvider } from './contexts/AuthContext'
import { ParticipantProvider } from './contexts/ParticipantContext'
import { ExpertProvider } from './contexts/ExpertContext'
import { Layout } from './components/Layout'
import ParticipantLayout from './components/layout/ParticipantLayout'
import ExpertLayout from './components/layout/ExpertLayout'
import { HomePage } from './pages/HomePage'
import { DashboardPage } from './pages/DashboardPage'
import { TestCasesPage } from './pages/TestCasesPage'
import { MetricsPage } from './pages/MetricsPage'
import { IQAIPage } from './pages/IQAIPage'
import { PreviewPage } from './pages/PreviewPage'
import { ExpertsManagementPage } from './pages/ExpertsManagementPage'
import { AdminRoute } from './components/AdminRoute'
import {
  ParticipantOnboardingPage,
  ParticipantInstructionsPage,
  ParticipantTaskPage,
  ParticipantFeedbackPage,
  ParticipantThankYouPage
} from './pages/participant'
import {
  ExpertWelcomePage,
  ExpertInstructionsPage,
  ExpertPersonasPage,
  ExpertEvaluationPage,
  ExpertSummaryPage
} from './pages/expert'
import { initializeRemoteConfig } from './lib/featureFlags'

function App() {
  // Initialize Firebase Remote Config on app startup
  useEffect(() => {
    initializeRemoteConfig().catch((error) => {
      console.error('[App] Failed to initialize Remote Config:', error)
    })
  }, [])
  return (
    <AuthProvider>
      <ParticipantProvider>
        <ExpertProvider>
          <Routes>
            {/* Public Login Page */}
            <Route path="/" element={<HomePage />} />

            {/* Admin Routes (Protected - only for admin role) */}
            <Route path="/" element={<Layout />}>
              <Route
                path="dashboard"
                element={
                  <AdminRoute>
                    <DashboardPage />
                  </AdminRoute>
                }
              />
              <Route
                path="test-cases"
                element={
                  <AdminRoute>
                    <TestCasesPage />
                  </AdminRoute>
                }
              />
              <Route
                path="metrics"
                element={
                  <AdminRoute>
                    <MetricsPage />
                  </AdminRoute>
                }
              />
              <Route
                path="iqai"
                element={
                  <AdminRoute>
                    <IQAIPage />
                  </AdminRoute>
                }
              />
              <Route
                path="especialistas"
                element={
                  <AdminRoute>
                    <ExpertsManagementPage />
                  </AdminRoute>
                }
              />
            </Route>

            {/* Preview Route (Public - for opening in new tab) */}
            <Route path="/preview/:executionId" element={<PreviewPage />} />

            {/* Participant Routes (Public) */}
            <Route path="/participante" element={<ParticipantLayout />}>
              <Route index element={<ParticipantOnboardingPage />} />
              <Route path="onboarding" element={<ParticipantOnboardingPage />} />
              <Route path="instrucoes" element={<ParticipantInstructionsPage />} />
              <Route path="tarefa/:taskIndex" element={<ParticipantTaskPage />} />
              <Route path="feedback/:taskIndex" element={<ParticipantFeedbackPage />} />
              <Route path="obrigado" element={<ParticipantThankYouPage />} />
            </Route>

            {/* Expert IQAI Routes (Admin only) */}
            <Route path="/especialista" element={<ExpertLayout />}>
              <Route index element={<AdminRoute><ExpertWelcomePage /></AdminRoute>} />
              <Route path="instrucoes" element={<AdminRoute><ExpertInstructionsPage /></AdminRoute>} />
              <Route path="personas" element={<AdminRoute><ExpertPersonasPage /></AdminRoute>} />
              <Route path="avaliacao/:index" element={<AdminRoute><ExpertEvaluationPage /></AdminRoute>} />
              <Route path="resumo" element={<AdminRoute><ExpertSummaryPage /></AdminRoute>} />
            </Route>
          </Routes>
        </ExpertProvider>
      </ParticipantProvider>
    </AuthProvider>
  )
}

export default App
